export function getNumberLabelsSprite ( actualNumber, n, res ) {

  const c = document.createElement( 'canvas' ),
    ctx = c.getContext( '2d' ),
    labelsSR = Math.sqrt( n ),
    labelWidth = res / labelsSR, 
    drawNumber = function ( number, offsetX, offsetY ) {

      let numberOffset = 0;

      if ( number > 9 ) numberOffset -= 18;
  
      ctx.beginPath();
      ctx.arc( 64 + offsetX, 64 + offsetY, 60, 0, 2 * Math.PI, false );
      ctx.fillStyle = '#fefefe';
      ctx.fill();
      ctx.lineWidth = 1;
      ctx.strokeStyle = '#003300';
      ctx.stroke();

      ctx.beginPath();
      ctx.arc( 64 + offsetX, 64 + offsetY, 52, 0, 2 * Math.PI, false );
      ctx.fillStyle = '#000';
      ctx.fill();
      ctx.stroke();

      ctx.font = "Bold 65px Arial";
      ctx.fillStyle = "#fefefe";
      ctx.strokeStyle = "rgba(255,255,255,1)";
      ctx.lineWidth = 2;
      ctx.fillText( number, 45 + offsetX + numberOffset, 86 + offsetY );

    };

  c.width = c.height = res;
  
  let x, y;

  for ( let i = 0 ; i < actualNumber ; i++ ) {

    x = ( i % labelsSR ) * labelWidth;
    y = Math.floor( i / labelsSR ) * labelWidth;

    drawNumber( i + 1, x, y );

  }
  
  const texture = new THREE.Texture( c );
  texture.needsUpdate = true;// ????

  return texture;

}

export function getNumberLabelsQuizzSprite () {

  const c = document.createElement( 'canvas' ),
    ctx = c.getContext( '2d' );

  c.width = c.height = 256;

  //question mark
  ctx.beginPath();
  ctx.arc( 64, 64, 60, 0, 2 * Math.PI, false );
  ctx.fillStyle = '#fefefe';
  ctx.fill();
  ctx.lineWidth = 1;
  ctx.strokeStyle = '#003300';
  ctx.stroke();

  ctx.beginPath();
  ctx.arc( 64, 64, 52, 0, 2 * Math.PI, false );
  ctx.fillStyle = '#000';
  ctx.fill();
  ctx.stroke();

  ctx.font = "Bold 65px Arial";
  ctx.fillStyle = "#fefefe";
  ctx.strokeStyle = "rgba(255,255,255,1)";
  ctx.lineWidth = 2;
  ctx.fillText( '?', 45, 86 );

  //check mark
  ctx.beginPath();
  ctx.arc( 64 + 128, 64, 60, 0, 2 * Math.PI, false );
  ctx.fillStyle = '#fefefe';
  ctx.fill();
  ctx.lineWidth = 1;
  ctx.strokeStyle = '#003300';
  ctx.stroke();

  ctx.beginPath();
  ctx.arc( 64 + 128, 64, 52, 0, 2 * Math.PI, false );
  ctx.fillStyle = '#000';
  ctx.fill();
  ctx.stroke();

  ctx.font = "Bold 65px Arial";
  ctx.fillStyle = "#fefefe";
  ctx.strokeStyle = "rgba(255,255,255,1)";
  ctx.lineWidth = 2;
  ctx.fillText( '\u2714', 38 + 128, 90 );

  //cross
  ctx.beginPath();
  ctx.arc( 64, 64 + 128, 60, 0, 2 * Math.PI, false );
  ctx.fillStyle = '#fefefe';
  ctx.fill();
  ctx.lineWidth = 1;
  ctx.strokeStyle = '#003300';
  ctx.stroke();

  ctx.beginPath();
  ctx.arc( 64, 64 + 128, 52, 0, 2 * Math.PI, false );
  ctx.fillStyle = '#000';
  ctx.fill();
  ctx.stroke();

  ctx.font = "Bold 65px Arial";
  ctx.fillStyle = "#fefefe";
  ctx.strokeStyle = "rgba(255,255,255,1)";
  ctx.lineWidth = 2;
  ctx.fillText( '\u2715', 36, 90 + 128 );
  
  const texture = new THREE.Texture( c );
  texture.needsUpdate = true;// ????

  return texture;

}